import React from 'react'
import { clsx } from 'clsx'

export type PageContainerMaxWidth = '2xl' | '3xl' | '4xl' | '7xl'

const MAX_WIDTH_CLASSES: Record<PageContainerMaxWidth, string> = {
  '2xl': 'max-w-2xl',
  '3xl': 'max-w-3xl',
  '4xl': 'max-w-4xl',
  '7xl': 'max-w-7xl'
}

interface PageContainerProps {
  children: React.ReactNode
  maxWidth?: PageContainerMaxWidth
  className?: string
}

export const PageContainer: React.FC<PageContainerProps> = ({ children, maxWidth = '7xl', className }) => {
  return (
    <div className={clsx('mx-auto px-4 py-6 sm:px-6 lg:px-8', MAX_WIDTH_CLASSES[maxWidth], className)}>
      {children}
    </div>
  )
}

export default PageContainer
